function fetchWrapper(url, options) {
    const retries = options && options.retries ? options && options.retries : 1;
    const timeoutRetry =
        options && options.timeoutRetry ? options && options.timeoutRetry : 5000;

    return new Promise(resolve => {
        const wrappedFetch = currentRetryCount => {
            fetch(url, options)
                .then(response => {
                    if (response.ok) {
                        // request successful, no need to retry
                        resolve(response);
                    } else {
                        if (currentRetryCount > 0) {
                            setTimeout(() => {
                                wrappedFetch(currentRetryCount - 1);
                            }, timeoutRetry);
                        } else {
                            // request failed after n retries, so we're done here
                            resolve(response);
                        }
                    }
                })
                .catch(response => {
                    if (currentRetryCount > 0) {
                        setTimeout(() => {
                            wrappedFetch(currentRetryCount - 1);
                        }, timeoutRetry);
                    } else {
                        // request failed after n retries, so we're done here
                        resolve(response);
                    }
                });
        };

        wrappedFetch(retries);
    });
}

export default fetchWrapper;
